import { Box } from '@mui/material'
import React, { useEffect } from 'react'
import defaultBg from "src/assets/bg-default.png";
import bgVideo from "src/assets/background-video.mp4";

const GlassBackground = () => {
  // useEffect(() => {
  //   let vid = document.getElementById("background-video");
  //   if(vid){
  //     vid.playbackRate = 0.7;
  //   }
  // },[])
  return (
    <>
      <style>
      {
        `.bg-gradient {
          z-index: -5;
          opacity: .2;
          filter: blur(70px);
          background-color: #5862ff;
          border-radius: 100vw;
          width: 80vw;
          height: 60vh;
          display: block;
          position: absolute;
        }`
      }
      </style>
      <Box
        id="background-overlay"
        sx={{
          position: "fixed",
          width: "100%",
          height: "100%",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: (theme) =>
            theme.palette.mode === "dark"
              ? "linear-gradient(180deg,hsla(0,0%,0%,0.4) 0%,hsla(0,0%,0%,0.1) 15%, hsla(0,0%,0%,0) 30%, hsla(0,0%,0%,0) 50%, hsla(0,0%,0%,0) 100%)"
              : "linear-gradient(180deg,hsla(0,0%,100%,0.4) 0%,hsla(0,0%,100%,0) 100%)",
          backgroundSize: "cover",
          zIndex: "-1",
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >
        <div class="bg-gradient"></div>
      </Box>
      <Box className="glass-background-image">
        <img
          src={defaultBg}
          width="100%"
          height="100%"
        />
        {/* <video 
          loop={true} 
          muted={true} 
          autoPlay={true} 
          playsInline={true}
          width="100%"
          height="100%"
          style={{backgroundImage: `url(${defaultBg})`, objectFit: "cover"}}
          id="background-video"
        >
          <source 
            src={bgVideo}
            data-wf-ignore="true"
          />
          <img
            src={defaultBg}
            width="100%"
            height="100%"
          />
        </video> */}
      </Box>
    </>
  )
}

export default GlassBackground